
<template>
  <listing
    v-if="item.type === 'listing'"
    :listing="item"
    class="feed-item"
  />
  <looking
    v-else-if="item.type === 'looking'"
    :looking="item"
    class="feed-item"
  />
  <post
    v-else-if="item.type === 'post'"
    :post="item"
    class="feed-item"
  />
  <advert
    v-else-if="item.type === 'advert'"
    :advert="item.data"
    class="feed-item"
  />
</template>

<script>
import Advert from '@/components/Advert.vue';
import Listing from '@/components/Listing.vue';
import Looking from '@/components/Looking.vue';
import Post from '@/components/Post.vue';

export default {
  components: {
    Advert,
    Listing,
    Looking,
    Post,
  },
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return {
      loading: false,
      error: false,
    };
  },
};
</script>

<style scoped>
  .feed-item {
    margin-top: 1rem;
  }
</style>
